// @flow

import { useEffect, useState } from 'react';

/**
 * Hook to track if a value has changed.
 *
 * @param {any} value
 */
const useHasChanged = (value: any) => {
  const [change, setChanged] = useState({ didChange: false, value });
  useEffect(() => {
    setChanged(prevState => {
      const didChange = prevState.value !== value;
      return { didChange, value };
    });
  }, [value]);
  return change.didChange;
};

export default useHasChanged;
